import React, { useState, useEffect } from "react";
import { Card, Typography, Row, Col, Spin, message } from "antd";
import {
  CarOutlined,
  UserOutlined,
  FileProtectOutlined,
  TeamOutlined,
  FileSearchOutlined,
  FileOutlined,
  DollarCircleOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import axios from "axios";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const { Title } = Typography;

const Home = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/dashboard");
      const { totals, groupedByMonth } = response.data;

      // Map grouped data to 12-month format
      const mapMonthlyData = (groupedData) => {
        const monthlyData = Array(12).fill(0);
        groupedData.forEach(({ month, count }) => {
          monthlyData[month - 1] = parseInt(count, 10);
        });
        return monthlyData;
      };

      setData({
        totals,
        monthlyData: {
          vehicles: mapMonthlyData(groupedByMonth.vehicles),
          drivers: mapMonthlyData(groupedByMonth.drivers),
          owners: mapMonthlyData(groupedByMonth.owners),
          inspections: mapMonthlyData(groupedByMonth.inspections),
          users: mapMonthlyData(groupedByMonth.customers),
          reservations: mapMonthlyData(groupedByMonth.reservations),
          rents: mapMonthlyData(groupedByMonth.transactions),
          agreements: mapMonthlyData(groupedByMonth.agreements),
        },
      });
      setLoading(false);
    } catch (error) {
      message.error("Failed to fetch dashboard data.");
      setLoading(false);
    }
  };

  const createChartData = (label, values) => ({
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label,
        data: values,
        backgroundColor: ["#4CAF50"],
      },
    ],
  });

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      {/* Overview Cards */}
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Vehicles"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <CarOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              {data.totals.vehicles}
            </Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Drivers"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <UserOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              {data.totals.drivers}
            </Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Owners"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <TeamOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              {data.totals.owners}
            </Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Inspections"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <FileSearchOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              {data.totals.inspections}
            </Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Users"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <FileProtectOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              5
            </Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Agreements"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <FileOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              {data.totals.agreements}
            </Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Reservations"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <ScheduleOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              {data.totals.reservations}
            </Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            bordered={false}
            title="Total Transactions"
            bodyStyle={{ padding: "24px" }}
            style={{ textAlign: "center" }}
          >
            <DollarCircleOutlined style={{ fontSize: "32px", color: "#4CAF50" }} />
            <Title level={2} style={{ fontWeight: "bold", color: "#4CAF50" }}>
              {data.totals.transactions}
            </Title>
          </Card>
        </Col>
      </Row>
<br /><br />
<br />
<br />
<br />
<br />

      {/* Monthly Charts */}
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card title="Vehicle Count" bordered={false}>
            <Bar
              data={createChartData("Vehicles", data.monthlyData.vehicles)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Driver Count" bordered={false}>
            <Bar
              data={createChartData("Drivers", data.monthlyData.drivers)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Owner Count" bordered={false}>
            <Bar
              data={createChartData("Owners", data.monthlyData.owners)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Inspection Count" bordered={false}>
            <Bar
              data={createChartData("Inspections", data.monthlyData.inspections)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="User Count" bordered={false}>
            <Bar
              data={createChartData("Users", data.monthlyData.users)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Reservation Count" bordered={false}>
            <Bar
              data={createChartData("Reservations", data.monthlyData.reservations)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Transaction Count" bordered={false}>
            <Bar
              data={createChartData("Transactions", data.monthlyData.rents)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Agreement Count" bordered={false}>
            <Bar
              data={createChartData("Agreements", data.monthlyData.agreements)}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Home;
